/* Keep personalization add-on lines (product "embroidery-personalization-add-on", property "For" = owner product title)
   in step with their item: same quantity as the owner, removed when the owner is removed.
   Runs after any cart change made by the theme (fetch to /cart/change|update), then refreshes the mini cart or reloads /cart. */
(function () {
  var FEE = 'embroidery-personalization-add-on', root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (!window.fetch || window.__cgcFeeSync) return; window.__cgcFeeSync = true;
  var nativeFetch = window.fetch.bind(window), busy = false;
  function wanted(cart) {
    var owners = {}, upd = {}, n = 0;
    cart.items.forEach(function (i) { if (i.handle !== FEE) owners[i.product_title] = (owners[i.product_title] || 0) + i.quantity; });
    var perOwner = {};
    cart.items.forEach(function (i) {
      if (i.handle !== FEE) return;
      var o = i.properties && i.properties._For, q = owners[o] || 0;
      // several identical owner lines share one title: fee qty = total owner qty
      if (i.quantity !== q) { upd[i.key] = q; n++; }
    });
    return n ? upd : null;
  }
  function refreshDrawer() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    nativeFetch(root + '?sections=ajax-cart,ajax-cart-icon').then(function (r) { return r.json(); }).then(function (s) {
      var p = new DOMParser();
      var drawer = document.getElementById('ajaxcart'), inner = s['ajax-cart'] && p.parseFromString(s['ajax-cart'], 'text/html').querySelector('.drawer-inner');
      if (drawer && inner) drawer.innerHTML = inner.innerHTML;
      var icon = document.getElementById('ajax-cart-icon'), ic = s['ajax-cart-icon'] && p.parseFromString(s['ajax-cart-icon'], 'text/html').querySelector('.shopify-section');
      if (icon && ic) { var cnt = ic.querySelector('[data-cgc-cart-count], .ajax-cart-count'), mine = document.querySelector('[data-cgc-cart-count], .ajax-cart-count'); if (cnt && mine) mine.textContent = cnt.textContent; }
    }).catch(function () {});
  }
  function sync() {
    if (busy) return; busy = true;
    nativeFetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var u = wanted(cart);
      if (!u) { busy = false; return; }
      return nativeFetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) })
        .then(function () { busy = false; refreshDrawer(); });
    }).catch(function () { busy = false; });
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) p.then(function () { setTimeout(sync, 150); }, function () {});
    return p;
  };
  if (/\/cart\/?$/.test(location.pathname)) sync();
})();
